import { render, staticRenderFns } from "./RenoReviewNoteRow.vue?vue&type=template&id=0a8cae00&scoped=true&"
import script from "./RenoReviewNoteRow.vue?vue&type=script&lang=ts&"
export * from "./RenoReviewNoteRow.vue?vue&type=script&lang=ts&"
import style0 from "./RenoReviewNoteRow.vue?vue&type=style&index=0&id=0a8cae00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8cae00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VChip,VIcon,VTextField})
